import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpApiService } from '../base/http-api.service';
import { ApiResponseModel } from '../../entities/api-response.model';
import { RawMaterialTypesModel } from '../../entities/raw-material-types.model';

@Injectable({
    providedIn: 'root'
})
export class RawMaterialTypeService {

    constructor(
        public httpApiService: HttpApiService,
    ) {

    }

    public get(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('raw-material-types/view', { uid });
    }

    public set(rawMaterialType: RawMaterialTypesModel): Observable<ApiResponseModel> {
        return this.httpApiService.httpPost('raw-material-types/store', rawMaterialType);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('raw-material-types/destroy', { uid });
    }
}
